export const REQUEST_TOKEN_KEY = "Authorization" as const;

export const ACCESS_TOKEN_KEY = "access-Token" as const;

export const REFRESH_TOKEN_KEY = "refresh-Token" as const;